// Áudio e vídeo no card "Arquivo" (PD-02).
//
// A extensão aqui só ESCOLHE A ROTA: mídia vai para `sources/midia`, que transcreve. Quem decide
// se o arquivo é mídia mesmo é o ffprobe no servidor, pelo conteúdo — um `.mp4` que não é vídeo
// volta com `formato_invalido`. A lista é a dos formatos da AssemblyAI mais os que o servidor
// converte (mkv, avi, wmv, 3gp, mpeg), para o cliente não precisar converter nada.
export const EXTENSOES_DE_MIDIA = [
  'mp3',
  'wav',
  'm4a',
  'aac',
  'ogg',
  'oga',
  'opus',
  'flac',
  'wma',
  'amr',
  'aif',
  'aiff',
  '3ga',
  'webm',
  'mp4',
  'm4v',
  'mov',
  'mts',
  'm2ts',
  'ts',
  'mxf',
  'flv',
  'mkv',
  'avi',
  'wmv',
  '3gp',
  'mpeg',
  'mpg',
];

// O mesmo teto do servidor (`PowerDataMidia::MAX_BYTES`). Conferir aqui evita subir 300 MB para
// ouvir "grande demais" no fim.
export const MAX_BYTES_MIDIA = 200 * 1024 * 1024;

// Os documentos espelham ALLOWED_EXTENSIONS do agent-admin (agents.py).
const EXTENSOES_DE_DOCUMENTO = [
  'pdf',
  'docx',
  'pptx',
  'txt',
  'csv',
  'md',
  'png',
  'jpg',
  'jpeg',
];

export const ACCEPT_ARQUIVO = [...EXTENSOES_DE_DOCUMENTO, ...EXTENSOES_DE_MIDIA]
  .map(ext => `.${ext}`)
  .join(',');

export function ehMidia(nome) {
  const ext = String(nome || '')
    .split('.')
    .pop()
    .toLowerCase();
  return String(nome || '').includes('.') && EXTENSOES_DE_MIDIA.includes(ext);
}

// Os motivos que têm frase própria na tela, na recusa do envio e no erro da transcrição.
export const MOTIVOS_DE_MIDIA = [
  'formato_invalido',
  'sem_audio',
  'longo_demais',
  'grande_demais',
  'sem_chave',
  'sem_fala',
  'falha_provedor',
  'falha_conversao',
  'tempo_esgotado',
];

// O motivo de um erro do `powerDataAPI` (que traz `status` e `codigo`). 413 é o nginx cortando
// antes do Rails: no sandbox o teto dele é 50 MB, abaixo do nosso.
export function motivoDoErro(erro) {
  if (erro?.status === 413) return 'grande_demais';
  return MOTIVOS_DE_MIDIA.includes(erro?.codigo) ? erro.codigo : '';
}
